import { IEmbedElementMod } from "@blings/blings-player";
import { Space } from "antd";
import { JsEditor } from "../../Editor/JsEditor";
import { LayerSelector } from "../../LayerSelector";
import { ModsPanelCompProps } from "../ModsPanel";

export const defaultFunctionForEmbedElementMod = () => {
  return `({ data, liveControlData, player, layerNode, foreignObject }) => {
  const root = document.createElement("div");
  root.style.cssText = "background:red; opacity:0.5; width:100%; height:100%;"
  // build your interactive HTML here, attach listeners, etc.

  return {
    node: root,
    // cleanup: () => { /* tear down listeners, timers, etc. */ },
  };
}`;
};

export function EmbedElementForm(props: ModsPanelCompProps<IEmbedElementMod>) {
  const config = props.change;
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <LayerSelector
        isMulti={false}
        assetLayerPairs={props.assetLayerPairs}
        selectedAssetId={config.assetId}
        selectedLayerName={config.layerName}
        selectedLayerUid={config.layerUid}
        onChange={props.onLayerChange}
        index={props.index}
        jsonVid={props.json}
      />
      <JsEditor
        defaultValue={
          config.functionString === ""
            ? defaultFunctionForEmbedElementMod()
            : config.functionString
        }
        onChange={(e: any) => props.onChange(props.index, "functionString", e)}
        runtimeContext="embedElement"
        tooltipText={`Return { node, cleanup? }. The node is mounted into a foreignObject inside the selected layer. Cleanup runs on player destroy.`}
      />
    </Space>
  );
}
